import { CheckCircle } from 'lucide-react';

const SessionStep = ({
  title,
  description,
  icon: Icon,
  isActive,
  isCompleted,
  isClickable = false
}) => (
  <div
    className={`flex items-center ${
      isActive
        ? "text-uzima-maroon-500"
        : isCompleted
        ? "text-green-600"
        : "text-gray-500"
    } ${isClickable ? 'group' : ''}`}
  >
    <div
      className={`
        h-10 w-10 rounded-full flex items-center justify-center transition-colors
        ${isActive 
          ? "bg-blue-100 border-2 border-uzima-maroon-500" 
          : isCompleted 
          ? "bg-green-100" 
          : "bg-gray-100"
        }
        ${isClickable && !isActive 
          ? 'group-hover:bg-gray-200' 
          : ''
        }
      `}
    >
      {isCompleted ? (
        <CheckCircle className="h-6 w-6" />
      ) : (
        <Icon className="h-6 w-6" />
      )}
    </div>
    <div className="ml-4">
      <p className={`text-sm font-medium ${isClickable ? 'group-hover:text-gray-700' : ''}`}>
        {title}
      </p>
      <p className={`text-xs ${isClickable ? 'group-hover:text-gray-600' : ''}`}>
        {description}
      </p>
      {isClickable && !isActive && (
        <p className="text-xs text-uzima-maroon-400 opacity-0 group-hover:opacity-100 transition-opacity">
          Click to navigate
        </p>
      )}
    </div>
  </div>
);

export default SessionStep;

// // src/components/counseling/session/SessionStep.jsx
// import { CheckCircle } from 'lucide-react';

// const SessionStep = ({
//     title,
//     description,
//     icon: Icon,
//     isActive,
//     isCompleted,
//   }) => (
//     <div
//       className={`flex items-center ${
//         isActive
//           ? "text-uzima-maroon-500"
//           : isCompleted
//           ? "text-green-600"
//           : "text-gray-500"
//       }`}
//     >
//       <div
//         className={`
//         h-10 w-10 rounded-full flex items-center justify-center
//         ${isActive ? "bg-blue-100" : isCompleted ? "bg-green-100" : "bg-gray-100"}
//       `}
//       >
//         {isCompleted ? (
//           <CheckCircle className="h-6 w-6" />
//         ) : (
//           <Icon className="h-6 w-6" />
//         )}
//       </div>
//       <div className="ml-4">
//         <p className="text-sm font-medium">{title}</p>
//         <p className="text-xs">{description}</p>
//       </div>
//     </div>
//   );
  
//   export default SessionStep;